import { enumGovernmentReportingServiceType } from '@rematter/frontend-lib-api-client';

export const getServiceTypeOptions = (labels: Record<string, string>) =>
  Object.values(enumGovernmentReportingServiceType).map((key) => ({
    key,
    label: labels[key] ?? key,
  }));
